export default String.raw`
.search-advanced-container {
    padding: 0 32px;
    &__search {
        width: 100%;
        margin-bottom: 24px;
    }

    &__find-by {
        margin-bottom: 32px;
    }

    &__price {
        div {
            margin-bottom: 32px - 24px;
        }
    }

    &__checkboxes {
        width: 100%;

        &-two-columns:nth-child(2n + 1) {
            grid-column: initial;
        }
    }
}
`